<script>
    import { onMount } from "svelte";
    import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
    import ComponentTiled from "./ComponentTiled.svelte";
    import { SetupStore } from "../stores/gameStore";
    import { AlchemistCounter } from "../stores/gameStore";
    import { PotionsDiscardPile } from "../stores/gameStore";
    import { getTextsAlchemistTokens } from "../../constants/allTexts";
    import PotionCard from "./PotionCard.svelte";

    export let tokenID, skill, scale, craftingTableFlip = false;

    $: alchemistSkills = $AlchemistCounter;
    $: discardPile = $PotionsDiscardPile;
  
    const _id = Math.round(Math.random() * 10000).toString();
    const textsTokens = getTextsAlchemistTokens();
    const textEmptyPile01 = _('There are no cards in the discard pile jet.');
    const textEmptyPile02 = _('Once there are any, you will see them here.');

    let showTooltip = false; // Controls the visibility of the tooltip
    let hideTimeout;
    
    let discardPile = $PotionsDiscardPile; // Accessing cards in the discard pile

    let cards = [];
    $: if (alchemistSkills["ALCHEMIST_TOKEN_03"] === true) {
          cards = discardPile.map((card) => ({
          id: card.id,
          name: $SetupStore.data.cards[card.id]?.name || "Unknown Card",
          description: $SetupStore.data.cards[card.id]?.description || "No description"
        }));
      }

    function handleMouseEnter() {
      clearTimeout(hideTimeout);
      showTooltip = true;
    }

    function handleMouseLeave() {
      hideTimeout = setTimeout(() => {
        showTooltip = false;
      }, 500); // Wait 500ms before hiding
    }

    function handleTooltipEnter() {
      clearTimeout(hideTimeout); // Cancel hiding when hovering over the tooltip
    }

    function handleTooltipLeave() {
      hideTimeout = setTimeout(() => {
        showTooltip = false;
      }, 500); // Wait 500ms before hiding
    }

    function handleOnClick() {
      if (showTooltip == true) {
        showTooltip = false;
        return;
      }
      showTooltip = true;
    }

    onMount(() => {
      const tokenData = $SetupStore.data.gameTokens[tokenID];
      window.GAME.addTooltipHtml(
        _id,
        `<div style="display:flex; flex-direction:column; max-width: 350px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">
              ${textsTokens[tokenID].name}
            </div>
            </div>
              <hr style="width:100%;"/>
              ${textsTokens[tokenID].description}
            </div>
          </div>`
      );
    });
</script>  

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
{#if tokenID == "ALCHEMIST_TOKEN_03"}

  <!-- Special Tooltip for Token Nr.3 -->
  <div class="alchemisttoken"
    style:position="absolute"
    style:left="{skill.offset[0] * scale}px"
    style:top="{skill.offset[1] * scale}px"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
    on:click={handleOnClick}
  >
    <ComponentTiled
      width={52 * scale}
      sprite={SPRITES["TOKENS"]}
      borderRadius={1}
      offset={alchemistSkills[tokenID] === true
      ? $SetupStore.data.gameTokens[tokenID].offset
      : $SetupStore.data.gameTokens[tokenID].offset_back}
      className="shadow-sm"
    />
  </div>

  {#if alchemistSkills["ALCHEMIST_TOKEN_03"] === true}
    <div class="dijitTooltipContainer tooltip" 
    class:visible={showTooltip}
    style:left="{craftingTableFlip === false ? skill.offset[0] * scale + 50 : skill.offset[0] * scale - 400}px"
    style:top="{skill.offset[1] * scale - 50}px"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
    >
      <div style="display:flex; flex-direction:column; width: 350px; word-wrap: break-word;">
          <div class="headline">
            {textsTokens["ALCHEMIST_TOKEN_03"].name}
          </div>
        <hr style="width:100%;"/>
        {textsTokens["ALCHEMIST_TOKEN_03"].description}
        <hr style="width:100%;"/>
        <div style="display:flex; flex-direction:row; flex-wrap:wrap; gap:10px;">
          {#each discardPile as card}
            <div
              class="card"
              on:click={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (alchemistSkills[tokenID] === true) {
                  window.GAME.bgaPerformAction("alchemistSkill", {
                    skillId: tokenID,
                    itemID: card,
                  });
                }
              }}
              >
                  <PotionCard
                  width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
                  card={$SetupStore.data.cards[card]}
                  active= 0
                  id={card}
                />
            </div>
          {/each}
          {#if (discardPile.length == 0)}
            {textEmptyPile01} <br>
            {textEmptyPile02}
          {/if}
        </div>
      </div>
    </div>
  {/if}

{:else}
  <!-- Standart-Tooltip for 3/4 Tokens -->
  <div class="alchemisttoken"
  style:position="absolute"
  style:left="{skill.offset[0] * scale}px"
  style:top="{skill.offset[1] * scale}px"
  id={_id}
  on:click={(e) => {
    e.preventDefault();
    e.stopPropagation();
    if (alchemistSkills[tokenID] === true) {
      window.GAME.bgaPerformAction("alchemistSkill", {
        skillId: tokenID,
        itemID: 0,
      });
    }
  }}
>
  <ComponentTiled
    width={52 * scale}
    sprite={SPRITES["TOKENS"]}
    borderRadius={1}
    offset={alchemistSkills[tokenID] === true
    ? $SetupStore.data.gameTokens[tokenID].offset
    : $SetupStore.data.gameTokens[tokenID].offset_back}
    className="shadow-sm"
  />
</div>
{/if}
  

<style>
    .alchemisttoken {
    position: absolute;
    cursor: pointer;
    border-radius: 50%;

    &:hover {
      filter: brightness(1.2);
    }
  }

  .tooltip {
    position: absolute;
    padding: 10px;
    border-radius: 5px;
    z-index: 999;
    display: none;
    pointer-events: none;
  }

  .tooltip.visible {
    display: block;
    pointer-events: auto; /* Allow clicks on visible cards */
    gap: 10px; /* Optional: add some space between the cards */
  }
  

  .card {
    &:hover {
      filter: brightness(1.2);
    }
  }
  
</style>